import axiosService from "../api/axios";

export const getBadgeProgressService = () => {
  return axiosService.get("/activity/badge-progress");
};
